import {FC, useEffect} from "react";
import {Outlet} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Preloader} from "components";
import {nonAuthRedirect} from "modules/actions";
import {isLoggedIn} from "modules/selectors";

export const NonAuthRoute: FC = () => {
	const dispatch = useDispatch();
	const isLogged = useSelector(isLoggedIn);

	// Redirect during the first render, if the user is logged in
	// If the user is authorized later, the redirect happens in the saga.
	useEffect(() => {
		dispatch(nonAuthRedirect());
	}, [dispatch]);

	if (isLogged) {
		return <Preloader />;
	}

	return <Outlet />;
};
